import React, { Component } from "react";
import { message } from "antd";
import moment from "moment";
import Fetch from "../../utils/fetch";
import StationChangeScreen from "../../components/selfHelp/stationChangeScreen";

import Screen from "../../components/selfHelp/screen";
import Header from "../../components/header";
import Footer from "../../components/customerLinkFooter";
import Map from "../../components/selfHelp/map";
import CabTracker from "../../components/cabTrackView/cabTracker";
import TripDetails from "../../components/selfHelp/trayContent/tripDetails";
import BusTimeline from "../../components/selfHelp/trayContent/busTimeline";
import CrewInformation from "../../components/selfHelp/trayContent/crewInformation";
import EmergencyContacts from "../../components/selfHelp/trayContent/emergencyContacts";
import SafetyVideos, {
  getSafetyVideos
} from "../../components/selfHelp/safetyVideos";
import VideoModal from "../../components/selfHelp/safetyVideos/videoModal";
import Policies from "../../components/selfHelp/trayContent/policiesInfo";
import BusDetails from "../../components/selfHelp/trayContent/busDetails";
import SeatUpdrade from "../../components/selfHelp/trayContent/seatUpgrade";
import CustomerSeats from "../../components/selfHelp/trayContent/customerSeats";
import NonMaxCustomerSeats from "../../components/selfHelp/trayContent/nonMaxCustomerSeats";

import CallBack from "../../components/selfHelp/trayContent/maxxCallBack";
// import OnTimeBanner from "../../components/selfHelp/trayContent/OTG";
// import MarketingBar from "../../components/marketingBar";
import {
  getWayPoints,
  getStationFromStationId,
  getTripStartTime
} from "../../utils/common";
import AppRedirectScreen from "../../components/appRedirectScreen";
import SOSModal from "../../components/selfHelp/sosModal";
import mixpanel from "mixpanel-browser";

import { mixPanelToken, isStage, b2cURL } from "../../config";
import OverlayScreen from "../../components/selfHelp/overlayScreen";
import TrackingOverlay from "../../components/selfHelp/trackingOverlay";
import BottomBar from "../../components/selfHelp/bottomBar";
import {
  fetchLastLocation,
  fetchSHPBooking,
  fetchStation,
  fetchBusRoute,
  markSafetyVideoWatched,
  fetchBusPhotos
} from "../../network";

import styles from "./selfhelp.module.scss";

import { googleLayerAnalytics } from "../../../src/utils/googleDataLayer";

import FoodOrderBanner from "../../components/FoodOrderBanner";

class SelfHelp extends Component {
  state = {
    loading: true,
    bookingId: this.props.match.params.bookingId,
    busMissed: false,
    booking: {},
    busRoute: [],
    eta: {},
    upcomingStation: {},
    tripStatus: "",
    isAndroid: false,
    lastlocation: {},
    openOverlayScreen: false,
    overlayScreenContent: null,
    overlayTitle: "",
    selectedStationOverlay: "",
    bus: {},
    busCatchPossible: false,
    boardingStationMarked: false,
    busHost: {},
    connectingFlag: false,
    appRedirect: false,
    busStartTime: null,
    isConnectingBooking: false,
    connectingFirstLegCompleted: false,
    setIsModalVisible: false,
    TrackingWorking: true,
    showEditBooking: false
  };

  showEditModal = value => {
    const { booking, inventory_type } = this.state;
    if (value === true) {
      mixpanel.init(mixPanelToken, { debug: isStage });
      mixpanel.track("Modify Booking ", {
        mobile_no: booking.mobileNo,
        pnr: booking.bookingCode,
        from_city: booking.boardingPoint.city,
        to_city: booking.dropPoint.city,
        from_station: booking.boardingPoint.address,
        to_station: booking.dropPoint.address,
        booking_source: booking.demandSource,
        inventory: "ZINGBUS",
        inventory_type
      });
    }
    this.setState({ showEditBooking: value });
  };
  handleOk = () => {
    this.setState({ setIsModalVisible: false });
  };
  openLink = value => {
    const { booking } = this.state;
    const { bookingCode, mobileNo, demandSource } = booking;

    mixpanel.init(mixPanelToken, { debug: isStage });

    let track = "";

    if (value === "Point_Change") {
      track = "Modify-Change BP/DP Clicked";
    } else if (value === "Reschedule_Booking") {
      track = "Modify-Reschedule Booking Clicked";
    } else {
      track = "Modify-Update Contact Details Clicked";
    }

    mixpanel.track(track, {
      mobile_no: booking.mobileNo,
      pnr: booking.bookingCode,
      from_city: booking.boardingPoint.city,
      to_city: booking.dropPoint.city,
      from_station: booking.boardingPoint.address,
      to_station: booking.dropPoint.address,
      booking_source: booking.demandSource
    });

    let link = b2cURL;
    link += `/selfhelp/login?bookingCode=${bookingCode}&mobileNo=${mobileNo}&updateType=${value}&bookingType=ZINGBUS&demandSource=${demandSource}`;
    window.open(link, "_self");
  };
  handleCancel = () => {
    this.setState({ setIsModalVisible: false });
  };
  openPlayStore = () => {
    const { booking } = this.state;
    mixpanel.init(mixPanelToken, { debug: isStage });
    mixpanel.track("Signup Clicked", {
      mobile_no: booking.mobileNo,
      trip_date: moment(booking.boardingPoint.time).format("YYYY-MM-DD"),
      pnr: booking.bookingCode,
      from_city: booking.boardingPoint.city,
      to_city: booking.dropPoint.city,
      from_station: booking.boardingPoint.address,
      to_station: booking.dropPoint.address,
      booking_source: booking.demandSource
    });
    googleLayerAnalytics("download_app_click", {
      mobile_no: booking.mobileNo,
      trip_date: moment(booking.boardingPoint.time).format("YYYY-MM-DD"),
      pnr: booking.bookingCode,
      from_city: booking.boardingPoint.city,
      to_city: booking.dropPoint.city,
      from_station: booking.boardingPoint.address,
      to_station: booking.dropPoint.address,
      booking_source: booking.demandSource
    });
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf("android") !== -1;
    if (isAndroid) {
      window.open(
        `https://play.google.com/store/apps/details?id=com.zingbusbtoc.zingbus`
      );
    } else {
      window.open(
        `https://apps.apple.com/in/app/zingbus-book-bus-ticket-online/id1600049529`
      );
    }
  };
  async componentDidMount() {
    this.fetchData();

    this.interval = setInterval(() => {
      this.checkIsTrackingWorking();
    }, 10 * 60 * 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }
  checkIsTrackingWorking = () => {
    const { lastDataRecievedAt } = this.state;
    if (lastDataRecievedAt < Date.now() - 10 * 60 * 1000) {
      this.setState({ TrackingWorking: false });
    }
  };

  checkLastTime = data => {
    this.setState({ lastDataRecievedAt: data });
  };

  fetchData = async bookingId => {
    try {
      const stateObj = { loading: false };

      const finalBookingId = bookingId ?? this.state.bookingId;

      let booking = await fetchSHPBooking(finalBookingId);

      if (booking.connectingBookingPnr && booking.connectingBooking) {
        this.setState({ isConnectingBooking: true });

        if (booking.trip.status === "COMPLETED") {
          booking = await fetchSHPBooking(booking.connectingBooking.id);
          this.setState({ connectingFirstLegCompleted: true });
        }
      }

      googleLayerAnalytics("page_view", {
        mobile_no: booking.mobileNo,
        pnr: booking.bookingCode,
        from_city: booking.boardingPoint?.city,
        to_city: booking.dropPoint?.city,
        from_station: booking.boardingPoint?.address,
        to_station: booking.dropPoint?.address,
        trip_date: moment(booking.boardingPoint?.time).format("YYYY-MM-DD"),
        booking_source: booking.demandSource,
        open_date: moment().format("YYYY-MM-DD"),
        seat_label: booking.tripChart?.[0]?.seatLabel ?? null
      });

      mixpanel.init(mixPanelToken, { debug: isStage });

      mixpanel.track("Self Help Page Viewed", {
        mobile_no: booking.mobileNo,
        pnr: booking.bookingCode,
        from_city: booking.boardingPoint?.city,
        to_city: booking.dropPoint?.city,
        from_station: booking.boardingPoint?.address,
        to_station: booking.dropPoint?.address,
        booking_source: booking.demandSource
      });

      this.getCustomerLatLng();

      window.onpopstate = () => {
        window.location.reload();
      };
      const [station, tripDetails] = await Promise.all([
        fetchStation(booking.tripId),
        fetchBusRoute(booking.tripId)
      ]);

      stateObj.station = station;
      stateObj.booking = booking;

      stateObj.tripStatus = tripDetails.status;
      stateObj.busRoute = tripDetails.busRoute;
      stateObj.busStartTime = tripDetails.busRoute[0].reachingTime;
      stateObj.isMaxService = tripDetails.service.isMaxService;
      stateObj.driverCabinSafetyEquipments =
        tripDetails.service.driverCabinSafetyEquipments;
      const { bus = {}, busHost = {}, busDriver = {} } = tripDetails;
      stateObj.bus = bus;
      stateObj.busHost = busHost;
      stateObj.busDriver = busDriver;
      if (
        Object.keys(bus).length &&
        Object.keys(busHost).length &&
        stateObj.tripStatus === "ACTIVE"
      ) {
        stateObj.tripStatus = "ASSIGNED";
      }

      if (Object.keys(bus).length && Object.keys(busHost).length) {
        stateObj.bus = {
          ...bus,
          busType: booking.busType
        };
      }

      // Photos live on the bus's onboarding audit, so they are only
      // available once a bus (and therefore an RC) has been mapped.
      if (bus && bus.rc) {
        fetchBusPhotos(bus.rc).then(busPhotos =>
          this.setState({ busPhotos: busPhotos || [] })
        );
      }

      const checkForTripPassenegerCompleted = tripDetails.busRoute.filter(
        obj => obj.stationId === booking.dropPoint.stationId
      )[0];

      if (checkForTripPassenegerCompleted.stationMarked === true) {
        stateObj.tripStatus = "COMPLETED";
      }
      stateObj.isAndroid = this.isRedirectRequired();

      // let timediff = d.getTime() - 15 * 60 * 1000;

      let boardingRouteCheck = tripDetails.busRoute.filter(
        obj => obj.station._id === booking.boardingPoint.stationId
      )[0];

      let boardingRoute = boardingRouteCheck;
      if (boardingRouteCheck.station.type == "VANPOINT") {
        boardingRoute = tripDetails.busRoute.filter(
          obj => obj.station._id === boardingRouteCheck.linkStationId
        )[0];

        booking.boardingPoint = {
          address: boardingRoute.station.address,
          city: boardingRoute.cityName,
          cityId: boardingRoute.station.cityId,
          lat: boardingRoute.station.lat,
          lng: boardingRoute.station.lng,
          name: boardingRoute.station.name,
          stationId: boardingRoute.stationId,
          time: boardingRoute.reachingTime
        };
      }

      let dropRouteCheck = tripDetails.busRoute.filter(
        obj => obj.station._id === booking.dropPoint.stationId
      )[0];

      if (dropRouteCheck.station.type == "VANPOINT") {
        let dropPoint = tripDetails.busRoute.filter(
          obj => obj.station._id === dropRouteCheck.linkStationId
        )[0];

        booking.dropPoint = {
          address: dropPoint.station.address,
          city: dropPoint.cityName,
          cityId: dropPoint.station.cityId,
          lat: dropPoint.station.lat,
          lng: dropPoint.station.lng,
          name: dropPoint.station.name,
          stationId: dropPoint.stationId,
          time: dropPoint.reachingTime
        };
      }

      tripDetails.busRoute = tripDetails.busRoute.filter(
        route => route.station.type !== "VANPOINT"
      );

      switch (stateObj.tripStatus) {
        case "ACTIVE": {
          stateObj.wayPoints = getWayPoints(
            tripDetails.busRoute,
            booking.boardingPoint.stationId,
            booking.dropPoint.stationId
          );

          break;
        }

        case "ASSIGNED": {
          stateObj.wayPoints = getWayPoints(
            tripDetails.busRoute,
            booking.boardingPoint.stationId,
            booking.dropPoint.stationId
          );

          break;
        }

        case "ONTRIP": {
          const lastlocation = await fetchLastLocation(booking.tripId);

          const upcomingStation = getStationFromStationId(
            lastlocation.upcomingStationId,
            tripDetails.busRoute
          );

          stateObj.boardingStationMarked = boardingRoute.stationMarked;

          stateObj.lastlocation = lastlocation;
          // Seed the GPS time now so the refreshed label doesn't show
          // "just now" until the map finishes loading and reports it.
          if (lastlocation && lastlocation.latlngDate) {
            stateObj.lastDataRecievedAt = lastlocation.latlngDate;
          }

          stateObj.upcomingStation = upcomingStation;
          stateObj.wayPoints = getWayPoints(
            tripDetails.busRoute,
            booking.boardingPoint.stationId,
            booking.dropPoint.stationId
          );
        }
      }
      let inventory_type;
      if (booking.trip.service.lobType == "PLUS") {
        inventory_type = "PLUS";
      }
      if (tripDetails.service.isMaxService) {
        inventory_type = "MAXX";
      }
      if (booking.serviceHub == "Bharat") {
        inventory_type = "BHARAT";
      }
      if (booking.cabServiceType === "FIRSTMILE") {
        inventory_type = "FIRSTMILE";
      }
      if (booking.cabServiceType === "LASTMILE") {
        inventory_type = "LASTMILE";
      }
      stateObj.inventory_type = inventory_type;
      stateObj.serviceTier = stateObj.isMaxService ? "MAXX" : "PLUS";

      // Independent of the food/amenity calls below, so fire it now and
      // await it later instead of adding another round trip to page load.
      const {
        showUpgradeBanner,
        upgradeScope
      } = this.checkSeatUpgradeBannerVisibility(
        booking,
        inventory_type,
        booking.showUpgradeBanner
      );
      const seatUpgradePromise = showUpgradeBanner
        ? this.fetchIsSeatUpgradeAvailable(booking, upgradeScope)
        : Promise.resolve(null);

      if (stateObj.inventory_type === "MAXX") {
        const [
          mealOptions,
          amenitiesOptions,
          requestedAmenity
        ] = await Promise.all([
          this.getDinnerOpt(booking.trip.serviceId),
          this.getAmenitiesOpt(booking.trip.serviceId),
          this.getReqAmenitiesOpt(booking.id, booking.tripId)
        ]);

        stateObj.mealOptions = mealOptions;
        stateObj.amenitiesOptions = amenitiesOptions;
        stateObj.requestedAmenity = requestedAmenity;

        if (stateObj.requestedAmenity && stateObj.booking.tripChart) {
          let tripChart = booking.tripChart.map(seat => {
            const reqAmenity = stateObj.requestedAmenity.filter(
              req => req.seatId === seat.seatId
            );
            if (reqAmenity) {
              seat.requestedAmenity = reqAmenity.map(r => r.amenity);

              seat.requestedAmenity = reqAmenity.map(r => ({
                ...r.amenity,
                status: r.status,
                requestId: r._id
              }));
            }

            return seat;
          });
          stateObj.booking.tripChart = tripChart;
        }
      } else {
        stateObj.nonMaxxMeals = await this.getNonMaxxRequestedMeals(
          booking,
          booking.id,
          booking.tripId,
          tripDetails.busRoute
        );
      }

      if (showUpgradeBanner) {
        const seatUpgrade = await seatUpgradePromise;
        stateObj.isSeatUpgradeEligible =
          (seatUpgrade && seatUpgrade.isSeatUpgradeEligible) || false;
      }

      if (booking.isSeatUpgraded) {
        stateObj.isSeatUpgradeEligible = true;
      }

      stateObj.isLoungePassAvailable = booking.tripChart.some(
        seat => seat.loungePassBought
      );
      stateObj.lastRefreshedAt = Date.now();
      this.setState(stateObj);
    } catch (error) {
      this.setState({ loading: false });
    }
  };
  // Post boarding the unwatched videos are shown in order: the intro first
  // (skippable), then the emergency exit one, which cannot be dismissed.
  getPendingSafetyVideo = () => {
    const { booking } = this.state;

    if (!booking.isOnboarded) {
      return null;
    }

    return getSafetyVideos(booking).find(video => !video.isWatched) || null;
  };

  onSafetyVideoWatched = videoType => {
    this.setState(({ booking }) => ({
      booking: {
        ...booking,
        ...(videoType === "BUS_INTRO"
          ? { isBusIntroVideoWatched: true }
          : { isEmergencyExitVideoWatched: true })
      }
    }));
  };

  confirmSafetyVideo = async video => {
    this.onSafetyVideoWatched(video.type);

    try {
      await markSafetyVideoWatched({
        bookingId: this.state.booking.id || this.state.booking._id,
        videoType: video.type
      });
    } catch (error) {
      console.log(error);
    }
  };

  // The intro video is optional, so skipping it counts as done — it is marked
  // watched so the popup does not return on later visits.
  skipSafetyVideo = video => {
    this.confirmSafetyVideo(video);
  };

  updateEmergencyContacts = alternateEmergencyContactDetails => {
    this.setState(({ booking }) => ({
      booking: { ...booking, alternateEmergencyContactDetails }
    }));
  };

  getTrackingOverlay = () => {
    const {
      booking,
      lastRefreshedAt,
      tripStatus,
      eta,
      upcomingStation,
      lastlocation,
      lastDataRecievedAt,
      boardingStationMarked
    } = this.state;

    let isTrackingWorking = false;
    if (!!booking.trip.isTrackingWorking == false) {
      isTrackingWorking = true;
    }

    return (
      <TrackingOverlay
        booking={booking}
        lastRefreshedAt={lastRefreshedAt}
        tripStatus={tripStatus}
        eta={eta}
        upcomingStation={upcomingStation}
        lastlocation={lastlocation}
        lastDataRecievedAt={lastDataRecievedAt}
        isTrackingWorking={isTrackingWorking}
        boardingStationMarked={boardingStationMarked}
      />
    );
  };

  handleScroll = () => {
    window.scroll({
      top: document.body.offsetHeight,
      left: 0,
      behavior: "smooth"
    });
  };

  checkSeatUpgradeBannerVisibility = (
    booking,
    inventory_type,
    showUpgradeBanner
  ) => {
    try {
      const {
        foodOrderId,
        isBusUpgradeEligible,
        isSeatUpgradeEligible,
        firstMileLeadDetails,
        cabPickDropPnr
      } = booking;
      let upgradeScope = "BOTH";
      const isMaxxService = inventory_type === "MAXX";
      const isInterBusRestricted =
        isMaxxService || foodOrderId || firstMileLeadDetails || cabPickDropPnr;

      if (!isBusUpgradeEligible && !isSeatUpgradeEligible) {
        showUpgradeBanner = false;
      }

      if (!isBusUpgradeEligible && isSeatUpgradeEligible) {
        upgradeScope = "INTRABUS";
      }

      if (
        !isSeatUpgradeEligible &&
        isBusUpgradeEligible &&
        upgradeScope === "BOTH"
      ) {
        upgradeScope = "INTERBUS";
      }

      if (isInterBusRestricted) {
        if (isSeatUpgradeEligible) {
          upgradeScope = "INTRABUS";
        } else {
          showUpgradeBanner = false;
        }
      }

      if (cabPickDropPnr) {
        showUpgradeBanner = false;
      }
      return { showUpgradeBanner, upgradeScope };
    } catch (error) {
      console.log(error);
      return { showUpgradeBanner: false, upgradeScope: "BOTH" };
    }
  };

  fetchIsSeatUpgradeAvailable = async (booking, upgradeScope) => {
    try {
      const {
        bookingCode,
        id,
        tripId,
        boardingPoint,
        dropPoint,
        connectingBookingPnr
      } = booking;
      const fromCityId = boardingPoint.cityId;
      const toCityId = dropPoint.cityId;
      const fromStationId = boardingPoint.stationId;
      const toStationId = dropPoint.stationId;
      const fromStationDate = boardingPoint.time;
      const path = `/booking/seatUpgrade?_id=${id}&bookingCode=${
        connectingBookingPnr ? connectingBookingPnr : bookingCode
      }&tripId=${tripId}&fromCityId=${fromCityId}&toCityId=${toCityId}&fromStationId=${fromStationId}&toStationId=${toStationId}&fromStationDate=${fromStationDate}&upgradeScope=${upgradeScope}`;
      const options = {
        method: "get"
      };

      let response = await Fetch(path, options);
      return response;
    } catch (err) {
      console.log(err);
    }
  };

  getDinnerOpt = async serviceId => {
    try {
      const path = `/booking/dinnerOpt/${serviceId}`;
      const options = {
        method: "get"
      };

      const dinnerOpt = await Fetch(path, options);
      return dinnerOpt;
    } catch (err) {
      console.log(err);
    }
  };

  getAmenitiesOpt = async serviceId => {
    try {
      const path = `/booking/amenitiesOpt/${serviceId}`;
      const options = {
        method: "get"
      };

      const amenitiesOpt = await Fetch(path, options);
      return amenitiesOpt;
    } catch (err) {
      console.log(err);
    }
  };

  getReqAmenitiesOpt = async (bookingId, tripId) => {
    try {
      const path = `/booking/amenitiesRequested/${bookingId}/${tripId}`;
      const options = {
        method: "get"
      };

      const amenitiesOpt = await Fetch(path, options);
      return amenitiesOpt;
    } catch (err) {
      console.log(err);
    }
  };

  checkAppFoodOrder = () => {
    const currentUrl = window.location.href;
    const urlObject = new URL(currentUrl);
    const params = new URLSearchParams(urlObject.search);

    const platform = params.get("initiator");
    if (!platform) {
      return true;
    }

    const version = params.get("appVersion");
    if (!version) {
      return true;
    }
    if (
      (platform === "B2CANDROID" && version >= "359") ||
      (platform === "B2CIOS" && version >= "542")
    ) {
      return true;
    }
  };

  checkAppMultiCityFoodMenu = () => {
    const currentUrl = window.location.href;
    const urlObject = new URL(currentUrl);
    const params = new URLSearchParams(urlObject.search);

    const platform = params.get("initiator");
    if (!platform) {
      return true;
    }

    const version = params.get("appVersion");
    if (!version) {
      return true;
    }
    if (
      (platform === "B2CANDROID" && parseInt(version) >= 376) ||
      (platform === "B2CIOS" && parseInt(version) >= 557)
    ) {
      return true;
    }
    return false;
  };

  getMidPointStationTimeMs = (
    busRoute,
    serviceId,
    tripStartTimeMs,
    midPointCityId
  ) => {
    const sortedRoute = (busRoute || [])
      .slice()
      .sort((a, b) => a.millisFromStart - b.millisFromStart);
    const midPointStation = sortedRoute.find(
      stop => stop.station && stop.station.cityId === midPointCityId
    );
    if (!midPointStation) {
      return null;
    }
    return tripStartTimeMs + midPointStation.millisFromStart;
  };

  resolveApplicableMenu = ({
    serviceFoodOptionsDoc,
    boardingCityId,
    tripStartTimeMs,
    midPointStationTimeMs
  }) => {
    const notEligible = {
      menu: null,
      foodOptionData: [],
      postPreTripCutOffOrder: false
    };
    if (!serviceFoodOptionsDoc) {
      return notEligible;
    }
    const { menuType } = serviceFoodOptionsDoc;

    if (menuType !== "SINGLE_CITY" && menuType !== "MULTI_CITY") {
      if (boardingCityId !== serviceFoodOptionsDoc.cityId) {
        return notEligible;
      }
      const cutOffTime = 9000000;

      const isBeforeCutoff = Date.now() <= tripStartTimeMs - cutOffTime;
      const isPostStationEligible =
        Date.now() >= tripStartTimeMs &&
        Date.now() <
          tripStartTimeMs +
            (serviceFoodOptionsDoc.postStationOrderEligibleHours || 0) *
              3600 *
              1000;
      if (!isBeforeCutoff && !isPostStationEligible) {
        return notEligible;
      }
      return {
        menu: "START",
        foodOptionData: serviceFoodOptionsDoc.foodOptionDetails || [],
        postPreTripCutOffOrder: !isBeforeCutoff
      };
    }

    const preTripCutoffMs =
      tripStartTimeMs -
      (serviceFoodOptionsDoc.preTripCutoffHours || 0) * 3600 * 1000;
    const isBeforePreTripCutoff = Date.now() <= preTripCutoffMs;

    if (menuType === "SINGLE_CITY") {
      if (boardingCityId !== serviceFoodOptionsDoc.cityId) {
        return notEligible;
      }
      if (!isBeforePreTripCutoff) {
        return notEligible;
      }
      return {
        menu: "START",
        foodOptionData: serviceFoodOptionsDoc.foodOptionDetails || [],
        postPreTripCutOffOrder: false
      };
    }

    const isStartCityBoarder = boardingCityId === serviceFoodOptionsDoc.cityId;
    const isMidPointCityBoarder =
      boardingCityId === serviceFoodOptionsDoc.midPointCityId;

    if (!isStartCityBoarder && !isMidPointCityBoarder) {
      return notEligible;
    }

    if (isStartCityBoarder && isBeforePreTripCutoff) {
      return {
        menu: "START",
        foodOptionData: serviceFoodOptionsDoc.foodOptionDetails || [],
        postPreTripCutOffOrder: false
      };
    }

    if (typeof midPointStationTimeMs !== "number") {
      return notEligible;
    }

    const midPointCutoffMs =
      midPointStationTimeMs -
      (serviceFoodOptionsDoc.midPointCutoffHours || 0) * 3600 * 1000;

    if (Date.now() <= midPointCutoffMs) {
      return {
        menu: "MID",
        foodOptionData: serviceFoodOptionsDoc.midCityFoodOptionDetails || [],
        postPreTripCutOffOrder: true
      };
    }

    return notEligible;
  };

  getNonMaxxRequestedMeals = async (booking, bookingId, tripId, busRoute) => {
    try {
      const {
        foodOrderId,
        isCoreBooking,
        boardingPoint,
        trip,
        connectingLegType,
        connectingBooking
      } = booking;

      const { service } = trip;
      const { foodOptionAvailable, _id } = service;
      const fromStationDate =
        connectingBooking && connectingLegType !== "FIRSTLEG"
          ? parseInt(connectingBooking.fromStationDate)
          : boardingPoint.time;

      const cancelCutOffTime = 21600000;
      let canOrderFood = false,
        canCancelFood = false;
      const serviceStartTime =
        parseInt(trip.tripDate) + parseInt(getTripStartTime(trip));

      if (!foodOrderId && isCoreBooking && foodOptionAvailable) {
        const path = `/booking/serviceFood/${_id}`;
        const options = { method: "get" };
        const serviceFoodOptionsRes = await Fetch(path, options);

        if (!serviceFoodOptionsRes) {
          canOrderFood = false;
        } else if (this.checkAppMultiCityFoodMenu()) {
          let midPointStationTimeMs = null;
          if (serviceFoodOptionsRes.menuType === "MULTI_CITY") {
            midPointStationTimeMs = this.getMidPointStationTimeMs(
              busRoute,
              service._id,
              serviceStartTime,
              serviceFoodOptionsRes.midPointCityId
            );
          }
          const applicableMenu = this.resolveApplicableMenu({
            serviceFoodOptionsDoc: serviceFoodOptionsRes,
            boardingCityId: boardingPoint.cityId,
            tripStartTimeMs: serviceStartTime,
            midPointStationTimeMs
          });
          canOrderFood =
            Boolean(applicableMenu.menu) &&
            applicableMenu.foodOptionData.length > 0;
        } else {
          const cutOffTime = 9000000;
          const now = Date.now();

          const beforeCutoff = now <= fromStationDate - cutOffTime;

          const postStationEligible =
            now >= fromStationDate &&
            now <
              fromStationDate +
                (serviceFoodOptionsRes.postStationOrderEligibleHours || 0) *
                  3600 *
                  1000;

          canOrderFood =
            (beforeCutoff || postStationEligible) &&
            serviceFoodOptionsRes.serviceIds?.includes(_id) &&
            serviceFoodOptionsRes.cityId === boardingPoint.cityId &&
            serviceFoodOptionsRes.foodOptionIds?.length > 0;
        }
      }

      if (Date.now() < parseInt(fromStationDate) - cancelCutOffTime) {
        canCancelFood = true;
      }
      const canModifyViaApp = this.checkAppFoodOrder();

      if (!canModifyViaApp) {
        canOrderFood = false;
        canCancelFood = false;
      }

      const path = `/booking/nonMaxxCustomerFood/${bookingId}/${tripId}`;
      const options = { method: "get" };

      const nonMaxxMeals = await Fetch(path, options);

      if (
        !nonMaxxMeals ||
        Object.keys(nonMaxxMeals).length === 0 ||
        !Array.isArray(nonMaxxMeals.orderedFoodItemsDetails) ||
        nonMaxxMeals.orderedFoodItemsDetails.length === 0
      ) {
        return {
          ...nonMaxxMeals,
          canOrderFood,
          canCancelFood,
          orderedFoodItemsDetails: []
        };
      }

      const grouped = Object.values(
        nonMaxxMeals.orderedFoodItemsDetails.reduce((acc, item) => {
          const id = item.orderedFoodItemId;

          if (!acc[id]) {
            acc[id] = {
              ...item,
              quantity: 0,
              totalPaid: 0,
              totalCost: 0
            };
          }

          acc[id].quantity += 1;
          acc[id].totalPaid +=
            (item.priceDetails && item.priceDetails.paidAmount) || 0;
          acc[id].totalCost +=
            (item.priceDetails && item.priceDetails.cost) || 0;

          return acc;
        }, {})
      );

      return {
        ...nonMaxxMeals,
        orderedFoodItemsDetails: grouped,
        canOrderFood,
        canCancelFood
      };
    } catch (err) {
      console.log(err);
      return {
        orderedFoodItemsDetails: []
      };
    }
  };

  getMarketingCards = async () => {
    try {
      const path = "/marketing/selfHelpPage?platform=SELFHELPPAGE";
      const options = {
        method: "get"
      };

      const marketingCards = await Fetch(path, options);

      return marketingCards;
    } catch (err) {
      console.log(err);
      message.error("Something went wrong");
    }
  };

  getCustomerLatLng = async () => {
    try {
      const path = "/bus-tracker/customerLat";
      const options = {
        method: "get"
      };

      let response = await Fetch(path, options);
      this.setState({ customerLat: response });
      return response;
    } catch (err) {
      console.log(err);
    }
  };

  isRedirectRequired = () => {
    const query = new URLSearchParams(this.props.location.search);
    return query.get("initiator") == "B2CANDROID";
  };

  handleChange = obj => {
    this.setState(obj);
  };

  onPassengerBoarded = data => {
    const { booking } = this.state;

    if (!booking.isOnboarded && data.bookingCode === booking.bookingCode) {
      window.location.reload();
    }
  };

  updateETA = data => {
    const { booking, upcomingStation, busRoute, station } = this.state;
    let isfirststation =
      booking.boardingPoint.stationId === busRoute[0].station._id;
    let isStationMarked = busRoute[0].stationMarked;

    //if first station reaching time is or not
    let firstStationtimeCheck = busRoute[0].reachingTime > Date.now();
    let delay = false;
    let early = false;
    let delayTimeSec = 0;
    let earlyTimeSec = 0;
    let reachingTime = booking.boardingPoint.time;
    let expectedReachingTime = station.filter(
      obj => obj.station._id == booking.boardingPoint.stationId
    )[0].expectedReachingTime;
    const boardingPointReachingTime = expectedReachingTime;

    if (booking.isOnboarded) {
      reachingTime = upcomingStation.reachingTime;
      expectedReachingTime = Date.now() + data.etaSec * 1000;
    }
    if (
      expectedReachingTime < reachingTime &&
      !isfirststation &&
      isStationMarked &&
      !firstStationtimeCheck
    ) {
      early = true;
      earlyTimeSec = expectedReachingTime;
    }
    if (reachingTime < expectedReachingTime) {
      delay = true;
      delayTimeSec = expectedReachingTime;
    }

    this.setState({
      eta: {
        text: data.eta,
        etaSec: data.etaSec,
        distanceMeters: data.distanceMeters,
        boardingPointReachingTime,
        delay,
        delayTimeSec,
        early,
        earlyTimeSec
      }
    });
  };

  toggleSOS = () => {
    let { booking, inventory_type } = this.state;
    mixpanel.init(mixPanelToken, { debug: isStage });
    mixpanel.track("SOS Clicked", {
      mobile_no: booking.mobileNo,
      pnr: booking.bookingCode,
      trip_date: moment(booking.boardingPoint.time).format("YYYY-MM-DD"),
      from_city: booking.boardingPoint.city,
      to_city: booking.dropPoint.city,
      from_station: booking.boardingPoint.address,
      to_station: booking.dropPoint.address,
      booking_source: booking.demandSource,
      view_from: "SOS Confirmation",
      inventory: "ZINGBUS",
      inventory_type
    });
    this.setState({ showSOSModal: true });
  };

  openWhatsApp = () => {
    let { booking, inventory_type } = this.state;
    mixpanel.init(mixPanelToken, { debug: isStage });
    mixpanel.track("Chat Support", {
      mobile_no: booking.mobileNo,
      pnr: booking.bookingCode,
      from_city: booking.fromCity.name,
      to_city: booking.toCity.name,
      from_station: booking.fromStationName,
      to_station: booking.toStationName,
      trip_date: moment(booking.fromStationDate).format("YYYY-MM-DD"),
      booking_source: booking.demandSource,
      view_from: "SOS Confirmation",
      inventory: "ZINGBUS",
      inventory_type
    });
    window.location.href =
      "https://api.whatsapp.com/send?phone=918287009889&text=zingbus";
  };

  raiseSOS = async reason => {
    try {
      let { booking, inventory_type } = this.state;
      let url = `/booking/raiseSOS/`;
      const marshalNumber =
        booking && booking.trip && booking.trip.busHost
          ? booking.trip.busHost.mobileNo
          : undefined;

      const serviceName =
        booking && booking.trip && booking.trip.service
          ? booking.trip.service.name
          : undefined;
      const options = {
        method: "post",
        data: {
          bookingCode: booking.bookingCode,
          number: booking.mobileNo,
          marshalNumber,
          reason,
          serviceName
        }
      };

      const response = await Fetch(url, options);
      if (Array.isArray(response) && response.length > 0) {
        booking = { ...booking, isSOSAlertInserted: true };
        mixpanel.init(mixPanelToken, { debug: isStage });
        mixpanel.track("SOS Confirm", {
          mobile_no: booking.mobileNo,
          pnr: booking.bookingCode,
          trip_date: moment(booking.boardingPoint.time).format("YYYY-MM-DD"),
          from_city: booking.boardingPoint.city,
          to_city: booking.dropPoint.city,
          from_station: booking.boardingPoint.address,
          to_station: booking.dropPoint.address,
          booking_source: booking.demandSource,
          inventory: "ZINGBUS",
          inventory_type
        });
        this.setState({ booking, showSOSModal: false });
      } else {
        message.error("Something went wrong");
      }
    } catch (err) {
      message.error(err);
    }
  };

  updateUpcomingStation = stationId => {
    const { upcomingStation, busRoute, booking } = this.state;

    const station = getStationFromStationId(stationId, busRoute);

    if (upcomingStation.stationId !== station.stationId) {
      const stateObj = { upcomingStation: station };

      // Check if bus is Missed

      if (
        !booking.isOnboarded &&
        station.reachingTime > booking.boardingPoint.time
      ) {
        // Bus missed case

        stateObj.wayPoints = getWayPoints(
          busRoute,
          booking.boardingPoint.stationId,
          booking.dropPoint.stationId
        );

        stateObj.booking = { ...booking, isOnboarded: true };
      }

      this.setState(stateObj);
    }
  };

  getMap = () => {
    // FM/LM cab legs are tracked by the cab's own location, not the bus
    const {
      cabBookingGroupId,
      boardingPoint,
      dropPoint,
      status
    } = this.state.booking;
    if (cabBookingGroupId && status !== "CANCELLED") {
      return (
        <div className={styles.cabTracking}>
          <CabTracker
            cabBookingGroupId={cabBookingGroupId}
            pickupStationId={boardingPoint && boardingPoint.stationId}
            dropStationId={dropPoint && dropPoint.stationId}
          />
        </div>
      );
    }

    const {
      booking,
      wayPoints,
      tripStatus,
      lastlocation,
      upcomingStation,
      busRoute,
      station,
      TrackingWorking
    } = this.state;
    let isStationMarked = busRoute.filter(
      route => route.station._id == booking.boardingPoint.stationId
    )[0].stationMarked;
    return (
      <Map
        booking={booking}
        isStationMarked={isStationMarked}
        wayPoints={wayPoints}
        tripStatus={tripStatus}
        onPassengerBoarded={this.onPassengerBoarded}
        lastlocation={lastlocation}
        station={station}
        updateETA={this.updateETA}
        checkLastTime={this.checkLastTime}
        isTrackingWorking={booking.trip.isTrackingWorking}
        TrackingWorking={TrackingWorking}
        upcomingStation={upcomingStation}
        updateUpcomingStation={this.updateUpcomingStation}
      />
    );
  };

  checkDemandSource = () => {
    const currentUrl = window.location.href;
    const urlObject = new URL(currentUrl);
    const params = new URLSearchParams(urlObject.search);
    const hasDemandSource = params.has("demandSource");

    return hasDemandSource;
  };

  checkAppSeatUpdgrade = () => {
    const currentUrl = window.location.href;
    const urlObject = new URL(currentUrl);
    const params = new URLSearchParams(urlObject.search);
    const hasDemandSource = params.has("demandSource");
    if (!hasDemandSource) {
      return true;
    }
    const version = params.has("appVersion");
    if (hasDemandSource && version) {
      return true;
    }
  };

  upgradeSeat = () => {
    const { booking } = this.state;
    const {
      bookingCode,
      mobileNo,
      demandSource,
      connectingBookingPnr
    } = booking;

    mixpanel.init(mixPanelToken, { debug: isStage });

    let track = "Seat Upgrade Clicked";
    mixpanel.track(track, {
      mobile_no: booking.mobileNo,
      view_from: "Self Help Page",
      pnr: booking.bookingCode,
      from_city: booking.boardingPoint.city,
      to_city: booking.dropPoint.city,
      from_station: booking.boardingPoint.address,
      to_station: booking.dropPoint.address,
      demand_source: booking.demandSource,
      service_name: booking.trip.service.name,
      asset_type: booking.seatArrangementAssetType,
      seat_count: booking.tripChart.length
    });

    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage("openSeatUpgradeView");
      return;
    } else if (
      window.AndroidWebView &&
      typeof window.AndroidWebView.openSeatUpgradeView === "function"
    ) {
      window.AndroidWebView.openSeatUpgradeView();
      return;
    }
    const value = "Upgrade_Seat";
    let link = b2cURL;
    link += `/selfhelp/login?bookingCode=${
      connectingBookingPnr ? connectingBookingPnr : bookingCode
    }&mobileNo=${mobileNo}&updateType=${value}&bookingType=${
      connectingBookingPnr ? "FIRSTMILECONNECTING" : "ZINGBUS"
    }&demandSource=${demandSource}`;
    window.open(link, "_self");
  };

  orderFood = () => {
    const { booking, isAndroid } = this.state;

    const bookingCode = booking.connectingBookingCode
      ? booking.connectingBookingCode
      : booking.bookingCode;

    let bookingCollection = "ZINGBUS";

    if (bookingCode.startsWith("ZB")) {
      bookingCollection = "ZINGBUS";
    } else if (bookingCode.startsWith("ZM")) {
      bookingCollection = "MARKETPLACE";
    } else if (bookingCode.startsWith("ZC")) {
      bookingCollection = "FIRSTMILECONNECTING";
    } else {
      bookingCollection = "GDS";
    }

    mixpanel.init(mixPanelToken, { debug: isStage });

    let track = "Food Banner Clicked";
    mixpanel.track(track, {
      view_from: "Self Help Page",
      demand_source: booking.demandSource,
      service_name: booking.trip.service.name,
      trip_date: moment(booking.boardingPoint.time).format("DD-MM-YYYY"),
      pnr: bookingCode,
      from_city: booking.boardingPoint.city,
      to_city: booking.dropPoint.city,
      login_status: isAndroid
    });

    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage("purchaseFood");
      return;
    } else if (
      window.AndroidWebView &&
      typeof window.AndroidWebView.purchaseFood === "function"
    ) {
      window.AndroidWebView.purchaseFood();
      return;
    }
    const query = window.location.href;
    let link = b2cURL;
    link += `/booking/details?pnr=${bookingCode}&bookingCollection=${bookingCollection}&action=PURCHASEFOOD&referrer=${query}`;
    window.open(link, "_self");
  };

  handleFoodOrderCancel = () => {
    const { booking } = this.state;
    mixpanel.init(mixPanelToken, { debug: isStage });

    const bookingCode = booking.connectingBookingCode
      ? booking.connectingBookingCode
      : booking.bookingCode;

    let bookingCollection = "ZINGBUS";

    if (bookingCode.startsWith("ZB")) {
      bookingCollection = "ZINGBUS";
    } else if (bookingCode.startsWith("ZM")) {
      bookingCollection = "MARKETPLACE";
    } else if (bookingCode.startsWith("ZC")) {
      bookingCollection = "FIRSTMILECONNECTING";
    } else {
      bookingCollection = "GDS";
    }

    let track = "Order Food Clicked";
    mixpanel.track(track, {
      mobile_no: booking.mobileNo,
      view_from: "Self Help Page",
      pnr: bookingCode,
      from_city: booking.boardingPoint.city,
      to_city: booking.dropPoint.city,
      from_station: booking.boardingPoint.address,
      to_station: booking.dropPoint.address,
      demand_source: booking.demandSource,
      service_name: booking.trip.service.name,
      asset_type: booking.seatArrangementAssetType,
      seat_count: booking.tripChart.length
    });

    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage("cancelFoodOrder");
      return;
    } else if (
      window.AndroidWebView &&
      typeof window.AndroidWebView.cancelFoodOrder === "function"
    ) {
      window.AndroidWebView.cancelFoodOrder();
      return;
    }
    const query = window.location.href;
    let link = b2cURL;
    link += `/booking/details?pnr=${bookingCode}&bookingCollection=${bookingCollection}&action=CANCELFOOD&referrer=${query}`;
    window.open(link, "_self");
  };

  setEvents = (tabName, type) => {
    const { booking, inventory_type } = this.state;
    mixpanel.init(mixPanelToken, { debug: isStage });
    let event = "";
    if (type === "POLICY") {
      event = "Policy Tab Clicked";
    } else if (type === "INFO") {
      event = "Bus Info Tab Clicked";
    }
    mixpanel.track(event, {
      mobile_number: booking.mobileNo,
      view_from: "Self Help Page",
      pnr: booking.bookingCode,
      from_city: booking.boardingPoint.city,
      to_city: booking.dropPoint.city,
      from_station: booking.boardingPoint.address,
      to_station: booking.dropPoint.address,
      booking_source: booking.demandSource,
      service_name: booking.trip.service.name,
      inventory_type,
      departure_time: booking.boardingPoint.time,
      tab_name: tabName
    });
  };

  handleViewSeatLayout = async () => {
    const { booking, inventory_type } = this.state;
    const { trip } = booking;
    mixpanel.init(mixPanelToken, { debug: isStage });
    mixpanel.track("View Seat Layout Clicked", {
      mobile_number: booking.mobileNo,
      view_from: "Self Help Page",
      pnr: booking.bookingCode,
      from_city: booking.boardingPoint.city,
      to_city: booking.dropPoint.city,
      from_station: booking.boardingPoint.address,
      to_station: booking.dropPoint.address,
      booking_source: booking.demandSource,
      service_name: booking.trip.service.name,
      inventory_type,
      departure_time: booking.boardingPoint.time
    });

    const path = `/booking/seatLayout?serviceId=${trip.serviceId}`;
    const options = {
      method: "get"
    };

    let response = await Fetch(path, options);
    this.setState({
      seatLayout: response.seatLayoutResponse,
      driverCabinSafetyEquipments:
        response?.serviceData?.driverCabinSafetyEquipments,
      openOverlayScreen: true,
      overlayScreenContent: "SEAT_LAYOUT",
      overlayTitle: "Seat Layout"
    });
    // Implement the logic for viewing seat layout
  };

  handleBusInfo = async () => {
    const { booking, inventory_type } = this.state;
    const { trip } = booking;
    mixpanel.init(mixPanelToken, { debug: isStage });
    mixpanel.track("Bus Details Clicked", {
      mobile_number: booking.mobileNo,
      view_from: "Self Help Page",
      pnr: booking.bookingCode,
      from_city: booking.boardingPoint.city,
      to_city: booking.dropPoint.city,
      from_station: booking.boardingPoint.address,
      to_station: booking.dropPoint.address,
      booking_source: booking.demandSource,
      service_name: booking.trip.service.name,
      inventory_type,
      departure_time: booking.boardingPoint.time
    });

    const path = `/booking/busInfo?busId=${trip.busId}`;
    const options = {
      method: "get"
    };

    let response = await Fetch(path, options);
    this.setState({
      busInfo: response,
      openOverlayScreen: true,
      overlayScreenContent: "BUS_INFO",
      overlayTitle: "Bus Information"
    });
    // Implement the logic for viewing bus information
  };

  getTrayContent = () => {
    const {
      booking,
      busRoute,
      customerLat,
      isConnectingBooking,
      connectingFirstLegCompleted,
      isMaxService,
      inventory_type,
      serviceTier,
      tripStatus,
      bus,
      amenitiesOptions,
      nonMaxxMeals,
      isLoungePassAvailable,
      isSeatUpgradeEligible,
      driverCabinSafetyEquipments,
      busPhotos
    } = this.state;

    const isApp = this.checkDemandSource();
    let isSeatUpdgradeEligibleThrough = true;
    if (isSeatUpgradeEligible) {
      isSeatUpdgradeEligibleThrough = this.checkAppSeatUpdgrade();
    }

    let showModifyBooking = true;
    const isOnlineBooking =
      booking.demandSource == "B2CIOS" ||
      booking.demandSource == "B2CWEB" ||
      booking.demandSource == "B2CANDROID" ||
      booking.demandSource == "OTA";

    let containsMaxx = booking.bookingCode.includes("MAXX");

    if (
      booking.agentId ||
      !!booking.connectingLegType ||
      !isOnlineBooking ||
      !!booking.rescheduledToBookingCode ||
      !!booking.rescheduledFromBookingCode ||
      containsMaxx ||
      booking.cabPickDropPnr ||
      booking.serviceHub == "Bharat"
    ) {
      showModifyBooking = false;
    }

    if (booking.boardingPoint.time - 60 * 60 * 1000 < Date.now()) {
      showModifyBooking = false;
    }

    if (isApp || isConnectingBooking) {
      showModifyBooking = false;
    }

    if (
      nonMaxxMeals &&
      nonMaxxMeals.orderedFoodItemsDetails &&
      nonMaxxMeals.orderedFoodItemsDetails.length > 0
    ) {
      showModifyBooking = false;
    }

    //can select dinner option or not if stateObj.booking.boardingPoint.time -mealOptions.cutoffEndTime <= Date.now <= stateObj.booking.boardingPoint.time -mealOptions.cutoffStartTime
    let mealOptions = this.state.mealOptions;
    let showAmenityButton =
      isMaxService &&
      Date.now() <= booking.dropPoint.time - 60 * 60 * 1000 &&
      booking.isAmenitiesAvailable &&
      amenitiesOptions &&
      amenitiesOptions.amenities &&
      amenitiesOptions.amenities.length > 0;
    let cutoffTime, cutoffStartime, showDinnerButton, canSelectDinner;

    if (isMaxService) {
      cutoffTime = booking.boardingPoint.time - mealOptions.cutoffEndTime;
      cutoffStartime = booking.boardingPoint.time - mealOptions.cutoffStartTime;

      showDinnerButton = cutoffStartime <= Date.now();

      canSelectDinner =
        cutoffStartime <= Date.now() && Date.now() <= cutoffTime;
      if (
        mealOptions &&
        mealOptions.foodOptions &&
        mealOptions.foodOptions.length > 0 &&
        canSelectDinner
      ) {
        mealOptions = {
          ...mealOptions,
          foodOptions: [
            ...mealOptions.foodOptions,
            {
              _id: "skip",
              name: "Skip Meal",
              displayName: "Skip Meal",
              veg: true
            }
          ]
        };
      }
    }
    let boardingRouteCheck = busRoute.filter(
      obj => obj.station.type === "RESTSTOP"
    );
    boardingRouteCheck = boardingRouteCheck ? boardingRouteCheck[0] : null;

    if (
      boardingRouteCheck &&
      boardingRouteCheck.reachingTime < booking.boardingPoint.time
    ) {
      canSelectDinner = false;
    }
    if (!isMaxService || !booking.trip.foodOptionAvailable) {
      showDinnerButton = false;
      canSelectDinner = false;
    }

    const busDetails = bus;
    return (
      <>
        <div className={styles.trayCards}>
          <TripDetails
            inventory_type={inventory_type}
            serviceTier={serviceTier}
            tripStatus={tripStatus}
            connectingFirstLegCompleted={connectingFirstLegCompleted}
            booking={booking}
            busRoute={busRoute}
            isLoungePassAvailable={isLoungePassAvailable}
            showModifyBooking={showModifyBooking}
            showEditModal={this.showEditModal}
          />
          {isSeatUpgradeEligible && isSeatUpdgradeEligibleThrough ? (
            <SeatUpdrade
              redirectToSeatUpdrade={this.upgradeSeat}
              isSeatUpgraded={booking.isSeatUpgraded}
            />
          ) : null}

          {isMaxService ? (
            <CustomerSeats
              cutoffTime={cutoffTime}
              showDinnerButton={showDinnerButton}
              seats={booking.tripChart}
              booking={booking}
              busDetails={
                busDetails && busDetails.rc ? busDetails.rc : undefined
              }
              mealOptions={mealOptions}
              canSelectDinner={canSelectDinner}
              updateDinner={this.updateDinner}
              showAmenityButton={showAmenityButton}
              updateAmenities={this.updateAmenities}
              cancelAmenity={this.cancelAmenity}
              amenities={amenitiesOptions}
              isOnboarded={booking.isOnboarded}
            />
          ) : (
            <NonMaxCustomerSeats seats={booking.tripChart}>
              <FoodOrderBanner
                isApp={isApp}
                mealsDetails={nonMaxxMeals}
                onFoodOrderCancel={this.handleFoodOrderCancel}
                orderFood={this.orderFood}
                booking={booking}
              />
            </NonMaxCustomerSeats>
          )}

          {isMaxService ? (
            <CallBack
              booking={booking}
              busDetails={
                busDetails && busDetails.rc ? busDetails.rc : undefined
              }
            />
          ) : null}

          {busDetails && busDetails.rc ? (
            <BusDetails
              busPhotos={busPhotos}
              driverCabinSafetyEquipments={driverCabinSafetyEquipments}
              booking={booking}
              inventory_type={inventory_type}
              serviceTier={serviceTier}
              maxPhotos={booking.maxxPhotos}
              corePhotos={booking.corePhotos}
              busDetails={busDetails}
              isMaxService={isMaxService}
              onViewSeatLayout={this.handleViewSeatLayout}
              showBusDetails={this.handleBusInfo}
            />
          ) : null}

          {/* {isPrime ? <OnTimeBanner booking={booking} /> : null} */}

          <SafetyVideos
            booking={booking}
            onVideoWatched={this.onSafetyVideoWatched}
          />

          <BusTimeline
            inventory_type={inventory_type}
            showStationChangeScreen={this.showStationChangeScreen}
            customerLatLng={customerLat}
            busRoute={busRoute}
            booking={booking}
            isLoungePassAvailable={isLoungePassAvailable}
            connectingFlag={this.state.connectingFlag}
            isConnectingBooking={isConnectingBooking}
          />
          {booking.trip && booking.trip.busDriver && booking.trip.busHost ? (
            <CrewInformation
              booking={booking}
              inventory_type={inventory_type}
            />
          ) : null}
          <EmergencyContacts
            booking={booking}
            onContactsUpdated={this.updateEmergencyContacts}
          />
          <Policies
            setEvents={this.setEvents}
            cancellationPolicy={booking.cancellationPolicy}
          />
        </div>

        <Footer booking={booking} isApp={isApp} />
      </>
    );
  };

  updateDinner = async (foodSelected, tripChartId, isFoodOptionSkipped) => {
    try {
      const { booking } = this.state;
      let url = `/booking/updateDinnerOpt/`;
      const options = {
        method: "post",
        data: {
          bookingCode: booking.bookingCode,
          tripChartId,
          foodSelected,
          isFoodOptionSkipped
        }
      };
      const response = await Fetch(url, options);
      if (Array.isArray(response) && response.length > 0) {
        booking.tripChart = booking.tripChart.map(chart => {
          if (chart.id === tripChartId) {
            if (isFoodOptionSkipped) {
              return {
                ...chart,
                isFoodOptionSkipped: true,
                foodSelected: undefined
              };
            } else {
              return {
                ...chart,
                isFoodOptionSkipped: false,
                foodSelected
              };
            }
          }
          return chart;
        });

        this.setState({ booking });
        return "success";
      } else {
        return "failed";
      }
    } catch (err) {
      message.error(err);
    }
  };

  updateAmenities = async (amenitiesSelected, seatId) => {
    try {
      const { booking } = this.state;
      const passengerName = booking.tripChart.filter(
        seat => seat.seatId == seatId
      )[0].name;

      let url = `/booking/updateAmenitiesOpt/`;
      const options = {
        method: "post",
        data: {
          passengerName,
          bookingId: booking.id,
          seatId,
          amenityIds: amenitiesSelected,
          requestCategory: booking.isOnboarded ? "ONBOARD" : "PRE_JOURNEY"
        }
      };
      const response = await Fetch(url, options);
      if (Array.isArray(response) && response.length > 0) {
        let allRequestedAmenities = [];

        booking.tripChart = booking.tripChart.map(chart => {
          const existingRequestedAmenity = chart.requestedAmenity || [];
          const updatedRequestedAmenity = [...existingRequestedAmenity];
          let timesAmenityRequested = chart.timesAmenityRequested || 0;

          const chartAmenities = response.filter(
            a => a.seatId === chart.seatId
          );

          if (chartAmenities.length > 0) {
            timesAmenityRequested += 1;
          }

          response.forEach(amenity => {
            if (amenity.seatId === chart.seatId) {
              this.state.amenitiesOptions.amenities.forEach(option => {
                if (option._id === amenity.amenityId) {
                  const newAmenity = {
                    ...option,
                    requestId: amenity._id,
                    status: amenity.status
                  };

                  const exists = updatedRequestedAmenity.some(
                    a => a._id === newAmenity._id
                  );

                  if (!exists) {
                    updatedRequestedAmenity.push(newAmenity);
                  }

                  allRequestedAmenities.push(newAmenity);
                }
              });
            }
          });

          return {
            ...chart,
            timesAmenityRequested: timesAmenityRequested,
            requestedAmenity: updatedRequestedAmenity
          };
        });

        this.setState({ booking, requestedAmenity: allRequestedAmenities });
        return "success";
      } else {
        return "failed";
      }
    } catch (err) {
      message.error(err);
    }
  };

  cancelAmenity = async requestId => {
    try {
      let url = `/booking/cancelAmenity/`;
      const options = {
        method: "post",
        data: {
          amenityIds: requestId
        }
      };
      const response = await Fetch(url, options);
      if (Array.isArray(response) && response.length > 0) {
        const { booking } = this.state;
        const seatId = response[0].seatId;
        // let requestedAmenity = this.state.requestedAmenity.filter(
        //   req => req.requestId !== requestId
        // );
        let requestedAmenity = this.state.requestedAmenity.map(req => {
          if (req.requestId === requestId) {
            return {
              ...req,
              status: "CANCELLED"
            };
          }
          return req;
        });
        booking.tripChart = booking.tripChart.map(chart => {
          if (chart.seatId === seatId) {
            let updatedRequestedAmenity = chart.requestedAmenity.map(req => {
              if (req.requestId === requestId) {
                return {
                  ...req,
                  status: "CANCELLED"
                };
              }
              return req;
            });
            return {
              ...chart,
              requestedAmenity: updatedRequestedAmenity
            };
          }
          return chart;
        });

        this.setState({ booking, requestedAmenity });
        return "success";
      } else {
        return "failed";
      }
    } catch (err) {
      message.error(err);
    }
  };

  showStationChangeScreen = (open, selectedStationOverlay = "") => {
    const stateObj = {
      openStationScreen: open,
      selectedStationOverlay
    };

    if (open) {
      stateObj.selectedStationOverlay = selectedStationOverlay;
    } else {
      window.history.back();
    }

    this.setState(stateObj);
  };
  changeBooking = () => {
    let { connectingFlag, booking } = this.state;
    if (connectingFlag) {
      this.setState({
        connectingFlag: false,
        loading: true
      });
      this.fetchData(this.props.match.params.bookingId);
    }
    if (
      booking.connectingBooking.boardingPoint.time - 4 * 60 * 60 * 1000 >
      Date.now()
    ) {
      this.setState({ setIsModalVisible: true });
    } else {
      this.setState({ connectingFlag: true, loading: true });
      this.fetchData(booking.connectingBooking.id);
    }
  };

  hideSOS = () => {
    let { booking, inventory_type } = this.state;
    mixpanel.init(mixPanelToken, { debug: isStage });
    mixpanel.track("SOS Cancelled", {
      mobile_no: booking.mobileNo,
      pnr: booking.bookingCode,
      trip_date: moment(booking.boardingPoint.time).format("YYYY-MM-DD"),
      from_city: booking.boardingPoint.city,
      to_city: booking.dropPoint.city,
      from_station: booking.boardingPoint.address,
      to_station: booking.dropPoint.address,
      booking_source: booking.demandSource,
      inventory: "ZINGBUS",
      inventory_type
    });
    this.setState({ showSOSModal: false });
  };

  optionSelected = () => {
    let { booking, inventory_type } = this.state;
    mixpanel.init(mixPanelToken, { debug: isStage });
    mixpanel.track("SOS REASON SELECTED", {
      mobile_no: booking.mobileNo,
      pnr: booking.bookingCode,
      trip_date: moment(booking.boardingPoint.time).format("YYYY-MM-DD"),
      from_city: booking.boardingPoint.city,
      to_city: booking.dropPoint.city,
      from_station: booking.boardingPoint.address,
      to_station: booking.dropPoint.address,
      booking_source: booking.demandSource,
      inventory: "ZINGBUS",
      inventory_type
    });
  };

  render() {
    const {
      loading,
      booking,
      openStationScreen,
      selectedStationOverlay,
      isAndroid,
      appRedirect,
      // showSOSModal = false,
      customerLat,
      showEditBooking,
      isLoungePassAvailable,
      openOverlayScreen,
      overlayScreenContent,
      overlayTitle,
      busInfo,
      seatLayout,
      driverCabinSafetyEquipments
    } = this.state;

    if (loading) {
      return (
        <div className="preloader">
          <img
            width={"90px"}
            src="https://d1flzashw70bti.cloudfront.net/original/images/cropped_loadertest.webp"
            alt="Loading"
          />
        </div>
      );
    }
    let isTrackingWorking = "";

    if (!!booking.trip.isTrackingWorking == false) {
      isTrackingWorking = true;
    }

    if (appRedirect) {
      return <AppRedirectScreen booking={booking} />;
    }

    const now = Date.now();

    const showSOS =
      now >= booking.boardingPoint.time - 30 * 60 * 1000 &&
      now <= booking.dropPoint.time + 1 * 60 * 60 * 1000;

    const pendingSafetyVideo = this.getPendingSafetyVideo();

    if (openOverlayScreen) {
      return (
        <OverlayScreen
          booking={booking}
          content={overlayScreenContent}
          title={overlayTitle}
          onClose={() => this.setState({ openOverlayScreen: false })}
          driverCabinSafetyEquipments={driverCabinSafetyEquipments}
          seatLayout={seatLayout}
          busInfo={busInfo}
          setEvents={this.setEvents}
        />
      );
    }

    return (
      <div className={styles.selfHelpContainer}>
        <Header isApp={isAndroid} booking={booking} SOS={this.toggleSOS} />

        <div className={styles.contentContainer}>
          {openStationScreen ? (
            <StationChangeScreen
              customerLatLng={customerLat}
              booking={booking}
              toggleStationScreen={this.showStationChangeScreen}
              overlayTitle={selectedStationOverlay}
            />
          ) : (
            <Screen
              tripStatus={booking.trip.status}
              map={this.getMap}
              tray={this.getTrayContent}
              overlay={this.getTrackingOverlay}
              tracking={isTrackingWorking}
            />
          )}
        </div>

        <BottomBar
          booking={booking}
          inventory_type={this.state.inventory_type}
          showSOS={showSOS}
          onEmergency={this.toggleSOS}
        />

        {pendingSafetyVideo ? (
          <VideoModal
            video={pendingSafetyVideo}
            isMandatory={pendingSafetyVideo.isMandatory}
            onConfirm={this.confirmSafetyVideo}
            onClose={() => this.skipSafetyVideo(pendingSafetyVideo)}
          />
        ) : null}
        {/* 
        <Modal
          centered
          width={"80%"}
          visible={showSOSModal}
          onOk={this.handleOk}
          footer={null}
          onCancel={() => this.hideSOS()}
        >
          <div className={styles.SOSModal}>
            <img
              src="https://d1flzashw70bti.cloudfront.net/original/images/selfhelp/SOS/request.svg"
              alt="info"
            />
            <p>Initiate SOS </p>
            <p>
              Initiate SOS services only in case of an emergency and use
              <b> WhatsApp chat for faster query resolution.</b> Once SOS is
              initiated our team will try to reach you as soon as possible.
            </p>
            <div onClick={this.openWhatsApp}>
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/selfhelp/SOS/whatsapp.svg"
                alt="whatsApp"
              />
              <span>WhatsApp Chat</span>
            </div>
            <div onClick={this.raiseSOS}>
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/selfhelp/SOS/info.svg"
                alt="sos"
              />
              <span>Initiate SOS</span>
            </div>
            <div onClick={() => this.hideSOS()}>
              <span>Cancel</span>
            </div>
          </div>
        </Modal> */}

        <SOSModal
          show={this.state.showSOSModal}
          onClose={() => this.hideSOS()}
          onConfirm={reason => {
            this.raiseSOS(reason);
            // Call API, show toast, etc.
          }}
          onOptionSelect={() => this.optionSelected()}
        />

        <div style={{ visibility: showEditBooking ? null : "hidden" }}>
          <div
            className={styles.overlay}
            onClick={() => {
              this.showEditModal(false);
            }}
          ></div>
          <div className={styles.editBooking}>
            <div className={styles.header}>
              <span>Modify Booking</span>
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/editBooking/close_small.svg"
                alt="close"
                onClick={() => {
                  this.showEditModal(false);
                }}
              />
            </div>
            {booking.isContactDetailsModified ? null : (
              <div
                className={styles.selectable}
                onClick={() => this.openLink("Modify_Contact_Details")}
              >
                <div>
                  <img
                    src="https://d1flzashw70bti.cloudfront.net/original/images/editBooking/phone.svg"
                    alt="phone"
                  />
                  <span>Modify Contact Details</span>
                </div>
                <img
                  src="https://d1flzashw70bti.cloudfront.net/original/images/editBooking/rightArrow.svg"
                  alt="arrow"
                />
              </div>
            )}

            {isLoungePassAvailable ? null : (
              <>
                <hr />

                <div
                  className={styles.selectable}
                  onClick={() => this.openLink("Reschedule_Booking")}
                >
                  <div>
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/editBooking/calendar.svg"
                      alt="calendar"
                    />
                    <span>Reschedule Booking </span>
                  </div>
                  <img
                    src="https://d1flzashw70bti.cloudfront.net/original/images/editBooking/rightArrow.svg"
                    alt="arrow"
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default SelfHelp;
